import zod from 'zod';
import { MANDATORY_FIELD } from '../../../config/zodConfig';
import { IntegrationFormSchema } from '../schemas';

export const SophiaIntegrationFormSchema = zod
  .object({
    login: zod
      .string({ required_error: MANDATORY_FIELD })
      .min(1, MANDATORY_FIELD),
    password: zod
      .string({ required_error: MANDATORY_FIELD })
      .min(1, MANDATORY_FIELD),
    schoolCode: zod
      .string({ required_error: MANDATORY_FIELD })
      .min(1, MANDATORY_FIELD),

  })
  .merge(IntegrationFormSchema);
